//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { computed, onMounted, ref, useContext } from "@nuxtjs/composition-api";
import blokProp from "~/helpers/blok-prop";
import isVideo from "~/helpers/is-video";
const __sfc_main = {};
__sfc_main.props = blokProp;

__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const heading = computed(() => props.blok.heading.replace(/℠/g, '<sup class="heading-mark caption">SM</sup>'));
  const {
    $vuetify
  } = useContext();
  const backgroundVideo = computed(() => {
    if (!isVideo(props.blok.backgroundMobile.filename)) return null;
    if (!isVideo(props.blok.backgroundDesktop.filename)) return null;

    if ($vuetify.breakpoint.smAndDown) {
      if (props.blok.backgroundMobile.filename) return props.blok.backgroundMobile;
      return props.blok.backgroundDesktop;
    }

    if (props.blok.backgroundDesktop.filename) return props.blok.backgroundDesktop;
    return props.blok.backgroundMobile;
  });
  const mounted = ref(false);
  onMounted(() => mounted.value = true);
  const backgroundImage = computed(() => {
    if (isVideo(props.blok.backgroundMobile.filename)) return null;
    if (isVideo(props.blok.backgroundDesktop.filename)) return null;
    if (props.blok.backgroundMobile.filename) return props.blok.backgroundMobile;
    return props.blok.backgroundDesktop;
  });
  return {
    heading,
    backgroundVideo,
    mounted,
    backgroundImage
  };
};

export default __sfc_main;
